import React, { useState, useEffect } from 'react';
import { Box, Container, Typography, CircularProgress } from '@mui/material';
import PublicNavBar from '../../components/PublicNavBar';
import PortalFooter from '../../components/PortalFooter';
import { contentAPI } from '../../services/api';

const DEFAULT = `Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und informieren Sie hiermit über die Verarbeitung Ihrer Daten gemäß Datenschutz-Grundverordnung (DSGVO).

Erhebung von Daten
Bei der Nutzung unserer Website werden personenbezogene Daten erhoben, wenn Sie diese freiwillig über Formulare eingeben. Dies umfasst insbesondere Name, E-Mail-Adresse, Telefonnummer und weitere Angaben, die Sie uns mitteilen.

Verwendung der Daten
Ihre Daten werden ausschließlich zur Erbringung unserer Dienstleistungen verwendet. Eine Weitergabe an Dritte erfolgt nicht ohne Ihre ausdrückliche Zustimmung.

Speicherung der Daten
Ihre Daten werden so lange gespeichert, wie dies für die Erbringung der Dienstleistung notwendig ist. Sie haben jederzeit das Recht, Ihre Daten zu löschen.

Ihre Rechte
Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer Daten. Sie können diese Rechte jederzeit geltend machen.

Kontakt zum Datenschutz
Bei Fragen zum Datenschutz kontaktieren Sie uns bitte unter datenschutz@callcenter-suche.de`;

const PrivacyPage: React.FC = () => {
  const [content, setContent] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    contentAPI.getAll()
      .then((res) => setContent(res.data.data?.content_privacy || DEFAULT))
      .catch(() => setContent(DEFAULT))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#f8f9fa', display: 'flex', flexDirection: 'column' }}>
      <PublicNavBar />
      <Container maxWidth="lg" sx={{ py: 6, flex: 1 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold', mb: 4 }}>
          Datenschutzerklärung
        </Typography>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <Typography sx={{ whiteSpace: 'pre-line', lineHeight: 1.9 }}>
            {content}
          </Typography>
        )}
      </Container>
      <PortalFooter />
    </Box>
  );
};

export default PrivacyPage;
